/**
 * Component: ShiftTypeSelection
 * @description Displays a list of shift types for selection, allowing the user to choose a specific type.
 *
 * @props
 *   @param {function} onSelect - Callback function triggered when a shift type is selected.
 *
 * @redux
 *   @selector selectAllShiftTypes - Retrieves the list of shift types from the Redux store.
 *
 * @render
 *   - Displays a button for each available shift type with its name.
 *   - Calls the `onSelect` function with the selected shift type when a button is clicked.
 *
 * @example
 * <ShiftTypeSelection
 *   onSelect={(shiftType) => console.log("Selected shift type:", shiftType)}
 * />
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';
import { selectAllShiftTypes } from '../../../redux/slices/shiftTypesSlice';

const ShiftTypeSelection = ({ onSelect }) => {
  const shiftTypes = useSelector(selectAllShiftTypes);

  return (
    <Box p={2}>
      <Typography variant="h6">Select a shift type</Typography>
      <Box mt={2} display="flex" flexDirection="column" gap={1}>
        {shiftTypes.length > 0 &&
          shiftTypes.map((shiftType, index) => (
            <Button key={index} onClick={() => onSelect(shiftType)} variant="secondary">
              {shiftType.name}
            </Button>
          ))}
      </Box>
    </Box>
  );
};

export default ShiftTypeSelection;
